export const SIGN_IN_IFRAME_ID = "sign_in_iframe"
